<app-page-header [title]="'pages.account' | transloco" />
<p-tabs
  [value]="currentTab"
  [dt]="{
    tablistBackground: 'transparent',
    tabBorderWidth: '0 0 2px 0',
    tabBackground: 'transparent',
    tabActiveBackground: 'transparent',
  }"
>
  <p-tablist>
    @for (tab of tabs; track tab.route) {
      <p-tab
        [value]="tab.route"
        [routerLink]="tab.route"
        class="flex items-center !gap-2 text-inherit"
      >
        <i [class]="tab.icon"></i>
        <span>{{ tab.label }}</span>
      </p-tab>
    }
  </p-tablist>
</p-tabs>
<div class="mt-6 max-w-3xl">
  <router-outlet />
</div>
